import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shared NZ region dropdown (Onboarding + Settings + region gate). North Island is
// listed first, then South Island, each roughly north -> south, with example towns in
// the labels of the split areas. Maps the chosen region to one of the 6 nz_X zones.
export function RegionPicker({ value, onChange, regions: regionsProp, zones: zonesProp, testId = 'region-select', className = '' }) {
  const [regions, setRegions] = useState(regionsProp || []);
  const [zones, setZones] = useState(zonesProp || {});

  useEffect(() => {
    if (regionsProp && regionsProp.length) { setRegions(regionsProp); return; }
    let active = true;
    axios.get(`${API}/regions`).then((r) => {
      if (!active) return;
      setRegions(r.data?.regions || []);
      setZones(r.data?.zones || {});
    }).catch(() => {});
    return () => { active = false; };
  }, [regionsProp]);

  useEffect(() => { if (zonesProp && Object.keys(zonesProp).length) setZones(zonesProp); }, [zonesProp]);

  const islands = [...new Set(regions.map((r) => r.island))];
  const selected = regions.find((r) => r.id === value);
  const inputCls = 'w-full px-4 py-3 bg-[#F0F2EB] border-transparent focus:border-[#8EAA97] focus:ring-2 focus:ring-[#8EAA97]/20 rounded-xl outline-none transition-all';

  return (
    <div>
      <select
        value={value || ''}
        onChange={(e) => {
          const reg = regions.find((r) => r.id === e.target.value);
          onChange(e.target.value || '', reg?.zone || '', reg?.label || '');
        }}
        data-testid={testId}
        className={className || inputCls}
      >
        <option value="">Select your region…</option>
        {islands.map((isl) => (
          <optgroup key={isl} label={isl}>
            {regions.filter((r) => r.island === isl).map((r) => (
              <option key={r.id} value={r.id}>{r.label}</option>
            ))}
          </optgroup>
        ))}
      </select>
      {selected ? (
        <p className="text-sm text-[#5C665C] mt-2" data-testid="region-zone-label">
          Climate zone: <span className="font-semibold text-[#1A4331]">{zones[selected.zone]?.label || selected.zone}</span>
        </p>
      ) : null}
    </div>
  );
}

export default RegionPicker;
